/* eslint-disable no-underscore-dangle */
/* istanbul ignore file */
import '@tvg/fuse/tvg-fuse.css';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { overridesCss } from '../../styles/overridesCss';
import Container from './Container';
import { ClientHydrationProps } from './ClientHydrationProps';
import setupDevApm from '../../utilities/loggerv2/setupDevApm';

if (process.env.NODE_ENV === 'development') {
  setupDevApm();
}

function ensureOverridesStyleTag() {
  const styleId = 'dcx-product-fe-overrides';
  if (document.getElementById(styleId)) return;

  const styleEl = document.createElement('style');
  styleEl.id = styleId;
  styleEl.appendChild(document.createTextNode(overridesCss));
  document.head.appendChild(styleEl);
}

function ContainerSuccess(props: ClientHydrationProps) {
  const {
    name,
    skus,
    brand,
    price,
    lowestPrice,
    description,
    identification,
    images,
    reviews,
    BV_URL,
    productId,
    returnable,
    dynamicPrice,
    features,
    trueFitEnabled,
    personalizableMaxLength,
    isInsuranceAvailable,
    promotionVoucher,
    digitalDownload,
    insuranceContent,
    roundel,
    linkedAddonServicesContent,
    tradeInValue,
    videos,
    promotionIdentifier,
    appleRichContentKey,
    tradingDepartmentId,
    site,
    weeeEligibilityInd,
    hasDeliveryContent,
    xMockResponseValue,
    featureToggles,
    experiments,
    fspProduct = false,
    mockDirectives,
  } = props;

  return (
    <Container
      name={name}
      skus={skus}
      brand={brand}
      price={price}
      lowestPrice={lowestPrice}
      description={description}
      identification={identification}
      images={images}
      reviews={reviews}
      BV_URL={BV_URL}
      productId={productId}
      features={features}
      returnable={returnable}
      dynamicPrice={dynamicPrice}
      trueFitEnabled={trueFitEnabled}
      personalizableMaxLength={personalizableMaxLength}
      isInsuranceAvailable={isInsuranceAvailable}
      promotionVoucher={promotionVoucher}
      digitalDownload={digitalDownload}
      insuranceContent={insuranceContent}
      roundel={roundel}
      linkedAddonServicesContent={linkedAddonServicesContent}
      tradeInValue={tradeInValue}
      videos={videos}
      promotionIdentifier={promotionIdentifier}
      appleRichContentKey={appleRichContentKey}
      tradingDepartmentId={tradingDepartmentId}
      site={site}
      weeeEligibilityInd={weeeEligibilityInd}
      hasDeliveryContent={hasDeliveryContent}
      xMockResponseValue={xMockResponseValue}
      featureToggles={featureToggles}
      experiments={experiments}
      fspProduct={fspProduct}
      mockDirectives={mockDirectives}
    />
  );
}
// eslint-disable-next-line no-underscore-dangle
if (window.__product_body_initial_state__) {
  ensureOverridesStyleTag();
  hydrateRoot(
    document.getElementById('productRoot') as HTMLElement,
    ContainerSuccess(window.__product_body_initial_state__),
  );
}
